import React, { useEffect, useState } from "react";
import useCoverageModal from "../../../../hooks/useCoverageModal";

const CoverageInfoModal = React.lazy(() =>
    import("../../../home-insurance/components/CoverageInfoModal/CoverageInfoModal")
);

function LazyCoverageInfoModal() {
    const {
        coverageInfoModal: { opened },
    } = useCoverageModal();
    const [_loaded, _setLoaded] = useState(opened);
    useEffect(() => {
        if (opened && !_loaded) {
            _setLoaded(true);
        }
    }, [_loaded, opened]);
    return (
        _loaded && (
            <React.Suspense fallback={null}>
                <CoverageInfoModal></CoverageInfoModal>
            </React.Suspense>
        )
    );
}

export default React.memo(LazyCoverageInfoModal);
